import {Image, Tag} from 'antd';
import {useIntl} from 'react-intl';
import './index.style.less';
import GoogleIconSVG from 'src/assets/icon/logo-google.svg';
import UserDefaultIconSVG from 'src/assets/icon/user-default.svg';
import UserDefaultGrayIconSVG from 'src/assets/icon/user-default-gray.svg';
import CloseCircleIconSVG from 'src/assets/icon/close-circle.svg';
import DotosVerticalIconSVG from 'src/assets/icon/dotos-vertical.svg';
import MinusCircleIconSVG from 'src/assets/icon/minus-circle.svg';
import BlusCircleIconSVG from 'src/assets/icon/blus-circle.svg';
import CheckCirclePrimaryIconSVG from 'src/assets/icon/check-circle-primary.svg';
import CheckCircleFillPrimaryIconSVG from 'src/assets/icon/check-circle-fill-primary.svg';
import CheckCircleIconSVG from 'src/assets/icon/check-circle.svg';
import ClipboardTextIconSVG from 'src/assets/icon/clipboard-text.svg';
import ListDropdownWhiteIconSVG from 'src/assets/icon/list-dropdown-white.svg';
import ListDropdownBlackIconSVG from 'src/assets/icon/list-dropdown-black.svg';

export declare type ColorTypes = 'white' | 'black' | 'gray' | 'primary';

declare type SafeNumber = number | `${number}`;

interface IconProps {
  className?: string;
  color?: ColorTypes;
  width?: SafeNumber | undefined;
  height?: SafeNumber | undefined;
  onClick?: () => void;
}
const GoogleIcon: React.FC<IconProps> = (props) => {
  const {messages} = useIntl();
  return (
    <Image
      src={GoogleIconSVG}
      alt={messages['common.google'].toString()}
      width={17.25}
      height={17.25}
      preview={false}
      className={`${props.className ?? ''}`}
      {...props}
    />
  );
};

const UserDefaultIcon: React.FC<IconProps> = (props) => {
  const {width, height} = props;
  const {messages} = useIntl();
  return (
    <Image
      src={UserDefaultIconSVG}
      alt={messages['common.user'].toString()}
      width={width ?? 17.25}
      height={height ?? 17.25}
      preview={false}
      className={
        props.className ? `icon-container ${props.className}` : 'icon-container'
      }
      {...props}
    />
  );
};

const UserDefaultGrayIcon: React.FC<IconProps> = (props) => {
  const {width, height} = props;
  const {messages} = useIntl();
  return (
    <Image
      src={UserDefaultGrayIconSVG}
      alt={messages['common.user'].toString()}
      width={width ?? 17.25}
      height={height ?? 17.25}
      preview={false}
      className={
        props.className ? `icon-container ${props.className}` : 'icon-container'
      }
      {...props}
    />
  );
};

const CloseCircleIcon: React.FC<IconProps> = (props) => {
  const {width, height} = props;
  const {messages} = useIntl();
  return (
    <Image
      src={CloseCircleIconSVG}
      alt={messages['common.close'].toString()}
      width={width ?? 17.25}
      height={height ?? 17.25}
      preview={false}
      className={
        props.className ? `icon-container ${props.className}` : 'icon-container'
      }
      {...props}
    />
  );
};

const DotosVerticalIcon: React.FC<IconProps> = (props) => {
  const {width, height} = props;
  const {messages} = useIntl();
  return (
    <Image
      src={DotosVerticalIconSVG}
      alt={messages['common.dotos'].toString()}
      width={width ?? 17.25}
      height={height ?? 17.25}
      preview={false}
      className={
        props.className ? `icon-container ${props.className}` : 'icon-container'
      }
      {...props}
    />
  );
};

const MinusCircleIcon: React.FC<IconProps> = (props) => {
  const {width, height} = props;
  const {messages} = useIntl();
  return (
    <Image
      src={MinusCircleIconSVG}
      alt={messages['common.minusCircle'].toString()}
      width={width ?? 17.25}
      height={height ?? 17.25}
      preview={false}
      className={
        props.className ? `icon-container ${props.className}` : 'icon-container'
      }
      {...props}
    />
  );
};

const BlusCircleIcon: React.FC<IconProps> = (props) => {
  const {width, height} = props;
  const {messages} = useIntl();
  return (
    <Image
      src={BlusCircleIconSVG}
      alt={messages['common.blusCircle'].toString()}
      width={width ?? 17.25}
      height={height ?? 17.25}
      preview={false}
      className={
        props.className ? `icon-container ${props.className}` : 'icon-container'
      }
      {...props}
    />
  );
};

const CheckCirclePrimaryIcon: React.FC<IconProps> = (props) => {
  const {width, height} = props;
  const {messages} = useIntl();
  return (
    <Image
      src={CheckCirclePrimaryIconSVG}
      alt={messages['common.checkCircle'].toString()}
      width={width ?? 17.25}
      height={height ?? 17.25}
      preview={false}
      className={
        props.className ? `icon-container ${props.className}` : 'icon-container'
      }
      {...props}
    />
  );
};

const CheckCircleFillPrimaryIcon: React.FC<IconProps> = (props) => {
  const {width, height} = props;
  const {messages} = useIntl();
  return (
    <Image
      src={CheckCircleFillPrimaryIconSVG}
      alt={messages['common.checkCircle'].toString()}
      width={width ?? 17.25}
      height={height ?? 17.25}
      preview={false}
      className={
        props.className ? `icon-container ${props.className}` : 'icon-container'
      }
      {...props}
    />
  );
};

const CheckCircleIcon: React.FC<IconProps> = (props) => {
  const {width, height} = props;
  const {messages} = useIntl();
  return (
    <Image
      src={CheckCircleIconSVG}
      alt={messages['common.checkCircle'].toString()}
      width={width ?? 17.25}
      height={height ?? 17.25}
      preview={false}
      className={
        props.className ? `icon-container ${props.className}` : 'icon-container'
      }
      {...props}
    />
  );
};

const ListDropdownIcon: React.FC<IconProps> = (props) => {
  const {width, height, color} = props;
  const {messages} = useIntl();
  return (
    <Image
      src={
        color === 'black' ? ListDropdownBlackIconSVG : ListDropdownWhiteIconSVG
      }
      alt={messages['common.checkCircle'].toString()}
      width={width ?? 17.25}
      height={height ?? 17.25}
      preview={false}
      className={
        props.className ? `icon-container ${props.className}` : 'icon-container'
      }
      {...props}
    />
  );
};

const ClipboardTextIcon: React.FC<IconProps> = (props) => {
  const {width, height} = props;
  const {messages} = useIntl();
  return (
    <Image
      src={ClipboardTextIconSVG}
      alt={messages['common.checkCircle'].toString()}
      width={width ?? 17.25}
      height={height ?? 17.25}
      preview={false}
      className={
        props.className ? `icon-container ${props.className}` : 'icon-container'
      }
      {...props}
    />
  );
};

const NotFound = () => {
  return <Tag className='ant-tag-disable-pointer'></Tag>;
};

export {
  GoogleIcon,
  UserDefaultIcon,
  UserDefaultGrayIcon,
  CloseCircleIcon,
  DotosVerticalIcon,
  MinusCircleIcon,
  BlusCircleIcon,
  CheckCirclePrimaryIcon,
  CheckCircleFillPrimaryIcon,
  CheckCircleIcon,
  ClipboardTextIcon,
  ListDropdownIcon,
  NotFound,
};
